<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc">Notes from Underground</h1>
<h1 class="sigil_not_in_toc">Fyodor Dostoyevsky</h1>
<div>
<br/>
</div>
<h2 class="sigil_not_in_toc">Copyright 2012<br/>
<br/>
<a href="http://otbebookpublishing.com" target="_blank">OUTSIDE THE BOX</a> ebook publishing</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ef1c7810